import React, { useState, useEffect } from 'react'
import Classes from './Services.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';
import PaymentLinkPopup from './PaymentLinkPopup/PaymentLinkPopup';
import { AnimatePresence } from 'framer-motion';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Services() {
    const initialclients = [
        { id: 1, service: "SEO", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 2, service: "Website Audit", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 3, service: "UI/UX", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 4, service: "Copywriting", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 5, service: "Front-end Development", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 6, service: "Back-end Development", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 7, service: "Full stack development", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
        { id: 8, service: "Full stack development", price: "$400.00", created: "March 1, 2025", updated: "March 1, 2025" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialclients.length / itemsPerPage);
    const currentItems = initialclients.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialclients.length);
    const totalItems = initialclients.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-service');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <div className={Classes.hero}>
                <div className={Classes.header}>
                    <div>
                        <h3>Services</h3>
                        <h5>Create and edit services for your clients.</h5>
                    </div>
                    <div>
                        <div className={Classes.searcCon}>
                            <img src="/assets/images/search.png" alt="icon" />
                            <input type="text" placeholder="Search..." />
                        </div>
                    </div>
                </div>

                <div className={Classes.table} >
                    <div className={Classes.tableWrapper}>
                        <div className={Classes.tableBanner} >
                            <div className='flexAlign10' >
                                <div className={Classes.tableBannerItem}>
                                    <h5>Clients</h5>
                                    <h4>3</h4>
                                </div>
                                <h5 className={Classes.allText} >All</h5>
                            </div>
                            <div>
                                <button onClick={handleAddOrder} className={Classes.addBtn}>
                                    <AddIcon height='12px' fill='white' />
                                    <h5>Add Service</h5>
                                </button>
                            </div>
                        </div>

                        <div className={Classes.tableHeader}>
                            <div className={`${Classes.headerItem} ${Classes.headerCustomer}`}>
                                <input type='checkbox' />
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerSpendings}`}>
                                <h5>Service</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerBookings}`}>
                                <h5>Price</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerDate}`}>
                                <h5>Created</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerDisable}`}>
                                <h5>Updated</h5>
                            </div>
                            <div className={`${Classes.headerItem} ${Classes.headerActions}`}>
                                {/* actions */}
                            </div>
                        </div>

                        <div className={Classes.tableBody}>
                            {loading ? (
                                <SkeletonLoading
                                    length={itemsPerPage}
                                    height={isMobile ? '6rem' : '2.8rem'}
                                    width="100%"
                                    br="6px"
                                />
                            ) : currentItems && currentItems.length > 0 ? (
                                currentItems.map((cust, idx) => (
                                    <TableRow
                                        key={cust._id}
                                        value={cust}
                                        index={idx}
                                    />
                                ))
                            ) : (
                                <div>No service found.</div>
                            )}
                        </div>

                        <div className={Classes.pagFooter}>
                            <h5 style={{ height: '1.2rem' }}>
                                {loading
                                    ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                    : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                                }
                            </h5>
                            <Stack spacing={2} className={Classes.pagination}>
                                {loading
                                    ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                    : <Pagination
                                        count={totalPages}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        shape="rounded"
                                    />
                                }
                            </Stack>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
